export default class PasswordComplexity {
    passwordMinLength: number;
    passwordIncludeUpperLetter: boolean;
    passwordIncludeLowerLetter: boolean;
    passwordIncludeNumber: boolean;
    passwordIncludeSpecial: boolean;
    passwordExcludeNames: boolean;

    constructor(mask: number) {
        let complexity = mask;
        complexity =
            !complexity || isNaN(Number(complexity))
                ? 180031
                : Number(complexity);
        const chars = Math.floor(complexity / 10000);
        const raw = complexity - chars * 10000;
        this.passwordMinLength = chars;
        this.passwordIncludeUpperLetter = (Math.pow(2, 0) & raw) > 0;
        this.passwordIncludeLowerLetter = (Math.pow(2, 1) & raw) > 0;
        this.passwordIncludeNumber = (Math.pow(2, 2) & raw) > 0;
        this.passwordIncludeSpecial = (Math.pow(2, 3) & raw) > 0;
        this.passwordExcludeNames = (Math.pow(2, 4) & raw) > 0;
    }

    toMask(): number {
        return (
            this.passwordMinLength * 10000 +
            (this.passwordIncludeUpperLetter ? Math.pow(2, 0) : 0) +
            (this.passwordIncludeLowerLetter ? Math.pow(2, 1) : 0) +
            (this.passwordIncludeNumber ? Math.pow(2, 2) : 0) +
            (this.passwordIncludeSpecial ? Math.pow(2, 3) : 0) +
            (this.passwordExcludeNames ? Math.pow(2, 4) : 0)
        );
    }
}
